import * as React from "react";
import {useEffect, useState} from "react";

import {useSelector} from "react-redux";
import {State} from "../reducer";
import {getMarqueEditorial, getMarqueEditorialWithCollections} from "../action/marqueEditorialAction";
import {getAdGroup} from "../action/adGroupAction";
import {getElibs} from "../action/elibAction"
import {MarqueGroupSelection} from "./ApplicationParameter/MarqueGroupSelection";
import {MarqueCollectionSelection} from "./ApplicationParameter/MarqueCollectionSelection";
import {CollectionNode, Node} from "../types";
import {loadParameterForMarqueOrCollection} from "../action/parametrageAction"
import {NBComplement} from "./ApplicationParameter/NBComplement";
import {CircularProgress, Fab, useTheme} from "@mui/material";
import {green} from "@mui/material/colors";
import {Grid, Divider, Tooltip} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import {NumberParameter} from "./ApplicationParameter/NumberParameter";
import {MarqueElibSelection} from "./ApplicationParameter/MarqueElibSelection";
import { useAppDispatch } from "../store";
import styled from '@emotion/styled';  
  

export const MarqueEditorialeParameter: React.FC = () => {
    const theme = useTheme();

    const Wrapper = styled('div')({
          margin: theme.spacing(1),
          position: 'relative'
    });
      
    const FabCircularProgress = styled(CircularProgress)({
          color: theme.palette.success.main,
          position: 'absolute',
          top: -2,
          left: -2,
          zIndex: 1,
        });

    const dispatch = useAppDispatch();

    useEffect(() => {
            dispatch(getMarqueEditorial());
            dispatch(getMarqueEditorialWithCollections());
            dispatch(getAdGroup());
            dispatch(getElibs());
        }, [dispatch]
    )

    const marqueEditorialList = useSelector(({marqueEditorial}: State) => marqueEditorial.marqueEditorial);
    const collectionList = useSelector(({marqueEditorial}: State) => marqueEditorial.collections);
    const adGroupList = useSelector(({adGroup}: State) => adGroup.adGroup);
    const elibs = useSelector(({elib}: State) => elib.elib);


    let [selectedMarqueCollection, setSelectedMarque] = useState<Node>();
    let [selectedCollection, setSelectedColl] = useState<CollectionNode>();
    const status = useSelector(({parametrage}: State) => parametrage.status);


    useEffect(() => {
        if (selectedMarqueCollection)
            dispatch(loadParameterForMarqueOrCollection({
                marqueId: selectedMarqueCollection.value,
                collectionId: selectedCollection?.value
            }))
    }, [selectedMarqueCollection, selectedCollection, dispatch])

    return (
        <>
            <Grid
                container
            >
                <Grid size={4}>
                    <h6>Groupe</h6>
                    <MarqueGroupSelection marqueCollections={marqueEditorialList}
                                          groups={adGroupList.map((e) => e.name)}
                    />

                </Grid>
                <Divider orientation="vertical" flexItem style={{marginLeft: 15, marginRight: 15}}/>
                <Grid size={7}>
                    <Grid>
                        <h6> Association Elib</h6>
                    </Grid>
                    <Grid>
                        <MarqueElibSelection elibs={elibs}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Divider style={{marginTop: 15, marginBottom: 15}}/>

            <Grid
                container
            >
                <Grid container style={{height: 55}} direction="row" justifyContent="space-between">
                    <Grid>
                        <h6> Association Marque Editoriale</h6>
                    </Grid>
                </Grid>
                <Grid size={6}>
                <MarqueCollectionSelection marqueCollections={collectionList}
                                           selectedMarqueCollection={selectedMarqueCollection}
                                           setSelectedMarqueCollection={setSelectedMarque}
                                           setSelectedCollection={setSelectedColl}
                                           selectedCollection={selectedCollection}
                                           children={
                                               status !== 'NONE' &&
                                               <Wrapper>
                                                   <Tooltip title={"Les paramètres sont à jour"}>
                                                       <Fab size={"small"}
                                                            aria-label="save"
                                                            style={{
                                                                cursor: "default",
                                                                background: status === 'SAVED' ? green[500] : "#3f51b5"
                                                            }}
                                                       >
                                                           {status === 'SAVED' ? <CheckIcon/> : <SaveIcon/>}
                                                       </Fab>
                                                   </Tooltip>
                                                   {status === 'IN_PROGRESS' &&
                                                   <Tooltip title={"Sauvegarde en cours"}>
                                                       <FabCircularProgress size={45}/>
                                                   </Tooltip>}
                                               </Wrapper>
                                           }
                />

                {selectedMarqueCollection && <Grid container style={{marginTop: 30}}>
                    <NBComplement marqueId={selectedMarqueCollection.value}
                                  collectionId={selectedCollection?.value}/>
                    <NumberParameter marqueId={selectedMarqueCollection.value}
                                     collectionId={selectedCollection?.value}
                                     parameterAttribute={'nbrJoursVerifComplCyc'}
                                     label={'Nombre de jours avant la mise en vente pour la vérification Cyclade'}/>
                    <NumberParameter marqueId={selectedMarqueCollection.value}
                                     collectionId={selectedCollection?.value}
                                     parameterAttribute={'nbrJoursVerifComplElib'}
                                     label={'Nombre de jours avant la mise en vente pour la vérification Elib'}/>
                </Grid>
                }
                </Grid>

                <Grid size={6}>

                </Grid>
            </Grid>

        </>
    )
}
